"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _card = _interopRequireDefault(require("@amzn/meridian-tokens/component/card"));

var _floatingBox = _interopRequireDefault(require("../_floating-box"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));

var _cardContext = _interopRequireDefault(require("../card/card-context"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var disabled = _ref.disabled,
      cardFocus = _ref.cardFocus,
      hover = _ref.hover,
      pressed = _ref.pressed,
      checked = _ref.checked;
  return (0, _emotion.css)({
    backgroundColor: disabled ? t("backgroundColorDisabled") : t("backgroundColor"),
    transition: "transform 0.1s ease, box-shadow 0.1s ease",
    transform: pressed ? "translateY(".concat(t("offsetVerticalPressed"), "px)") : undefined,
    boxShadow: pressed ? t.boxShadowCss("dropShadowHover") : undefined,
    "&:hover": {
      cursor: disabled ? "not-allowed" : "pointer",
      transform: !disabled ? "translateY(".concat(t(pressed ? "offsetVerticalPressed" : "offsetVerticalHover"), "px)") : undefined,
      boxShadow: t.boxShadowCss(pressed ? "dropShadowPressed" : "dropShadowHover")
    }
  }, !disabled && hover || !disabled && cardFocus || !disabled && checked ? (0, _focusRing["default"])(t.tokens, {
    focus: cardFocus || checked || hover,
    borderWidth: t("borderWidth"),
    borderRadius: t("borderRadius"),
    dropShadow: true,
    offset: 4,
    gapColor: t.themeBackgroundPrimaryDefault
  }) : undefined);
}, ["cardFocus", "checked", "hover", "disabled", "pressed"]);

var SelectableCard = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var checked = props.checked,
      children = props.children,
      disabled = props.disabled,
      name = props.name,
      onChange = props.onChange,
      value = props.value;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      cardFocus = _useState2[0],
      setCardFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(checked),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      pressed = _useState4[0],
      setPressed = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      hover = _useState6[0],
      setHover = _useState6[1];

  var t = (0, _theme.useTheme)(_card["default"], "card");

  var onClick = function onClick(event) {
    if (!disabled) {
      setPressed(!pressed); // If the value is a boolean (Checkbox), call onChange with its inverse

      if (typeof value === "boolean") {
        onChange(!value);
      } // Else call onChange with the value (Radio button)
      else {
        onChange(value);
      }
    } // Prevent the event's default behavior _unless_ we are the event is happening
    // directly on the <input> element.
    //
    // WHY? When a user clicks on selectable card's visual input (say the checkbox),
    // the browser calls the onClick _twice_ - once for the click on the visual input
    // (say the SVG) and then again for the invisible input (the <input type="checkbox">)
    // These two clicks effectively cancel eachother out.
    //
    // WHY NOT PREVENT DEFAULT ALWAYS? If we event.preventDefault() when the <input>
    // is clicked (e.g. a keyboard only user) screen readers will ignore the change.


    if (event.target.nodeName !== "INPUT") {
      event.preventDefault();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_cardContext["default"].Provider, {
    value: {
      checked: checked,
      disabled: disabled,
      hover: hover,
      name: name,
      onFocus: function onFocus() {
        return setCardFocus(true);
      },
      onBlur: function onBlur() {
        return setCardFocus(false);
      },
      value: value
    }
  }, /*#__PURE__*/_react["default"].createElement(_floatingBox["default"], (0, _extends2["default"])({}, props, {
    className: styles(t, {
      disabled: disabled,
      cardFocus: cardFocus,
      hover: hover,
      pressed: pressed,
      checked: checked
    }),
    onMouseEnter: function onMouseEnter() {
      if (!disabled) setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: onClick,
    tag: "div",
    ref: ref
  }), children));
});

SelectableCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The checked state of the card. Use this in conjunction with the
   * `onChange` prop to make the component interactive.
   *
   */
  checked: _propTypes["default"].bool,

  /**
   * The contents of the card.
   */
  children: _propTypes["default"].node,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * The value of the underlying input element. This is used to populate the
   * form data when submitting a form. To change the on/off status of the
   * component use the `checked` prop.
   */
  value: _propTypes["default"].any,

  /**
   * A function that will be called when the user attempts to change the checked
   * state of the component (e.g. by clicking on it). The new checked state will
   * be passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the checked state provided to this function somewhere in
   * your state and pass it back via the `checked` prop in order to make this
   * component interactive.
   */
  onChange: _propTypes["default"].func
} : {};
SelectableCard.defaultProps = {
  checked: false,
  disabled: false
};
SelectableCard.displayName = "SelectableCard";
var _default = SelectableCard;
exports["default"] = _default;